import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { ChangePasswordDto, UserNoPasswordNoRelations } from 'types';

export const updateUserPassword = ({
  data,
}: {
  data: ChangePasswordDto;
}): Promise<UserNoPasswordNoRelations> => {
  return axios.put(`/api/users/self/password`, data);
};

type UseUpdateUserPasswordOptions = {
  config?: MutationConfig<typeof updateUserPassword>;
};

export const useUpdateUserPassword = ({
  config,
}: UseUpdateUserPasswordOptions = {}) => {
  return useMutation({
    onSuccess: (data: UserNoPasswordNoRelations) => {
      queryClient.refetchQueries(['users', data.id]);
    },
    ...config,
    mutationFn: updateUserPassword,
  });
};
